import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

const SearchButton = ({ items = [], onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");

    const filteredItems = items.filter((item) =>
        item.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="relative inline-block text-black">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="rounded-full w-9 h-9 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
            >
                <FontAwesomeIcon icon={faSearch} className="text-lg text-watomsBlue" />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-60 bg-white rounded-xl shadow-lg border z-50 p-2">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-full px-3 py-2 mb-2 border rounded-lg"
                    />

                    <div className="max-h-60 overflow-y-auto">
                        {filteredItems.map((item, index) => (
                            <div
                                key={index}
                                onClick={() => {
                                    onSelect?.(item);   // 👈 send value to parent
                                    setIsOpen(false);   // close dropdown
                                }}
                                className="px-3 py-2 rounded-lg cursor-pointer hover:bg-gray-100"
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchButton;